(function ($) {

  $(".product-slider").slick({
    centerMode: true,
    slidesToShow: 1,
    centerPadding: "160px",
    dots: true,
    nextArrow: "<div class='right'><button><svg class='icon' aria-hidden='true' focusable='false'><use xlink:href='#chevron-right'></use></svg></button></div>",
    prevArrow: "<div class='left'><button><svg class='icon' aria-hidden='true' focusable='false'><use xlink:href='#chevron-left'></use></svg></button></div>",
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          centerPadding: "0px"
        }
      },
      {
        breakpoint: 769,
        settings: {
          centerPadding: "0px",
          dots: false,
          arrows: false
        }
      }
    ]

  });

  $(".about-slider").slick({
    autoplay: true,
    autoplaySpeed: 2000,
    fade: true,
    speed: 600,
    infinite: true
  });

  $(".basic-slider").slick({
    autoplay: true,
    autoplaySpeed: 2000,
    fade: true,
    speed: 600,
    infinite: true
  });

  $(".testimonial-slider").slick({

  });

})(jQuery);
